import { render } from "./Home.vue?vue&type=template&id=1fe0bfc6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=1fe0bfc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\krili\\Projects\\krilin_website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fe0bfc6"]])

export default __exports__